export default __webpack_public_path__ + "static/media/logo_colorida.604d38a0.png";